<template>
  <div class="discountDetails" :class="{modal}">
    <v-btn v-if="modal" icon class="closeDetails" :aria-label="$vuetify.lang.t('$vuetify.close')" @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
    <div v-if="expiryDate" class="couponContainer">
      <span class="coupon" aria-hidden="true" v-html="couponSvg"></span>
      <p class="validUntil">{{ $t("COUPON_VALID_UNTIL") }}</p>
      <p class="validUntilDate">{{ formatDate(expiryDate) }}</p>
    </div>
    <div class="steps">
      <h3 class="discountTitle">{{ $t("COUPON_TITLE") }}</h3>
      <div class="coupon" v-for="(coupon, index) in coupons" :key="index">
        <v-divider :class="{secondary: couponActive(coupon)}"/>
        <div v-if="coupon === nextCoupon" class="missingNext">
          <p v-html="$t('COUPON_VALUE_MISSING').replace('{value}', formatPrice((coupon.minimumValue - subtotal)))"></p>
          <v-icon class="rewardPointer secondary--text" size="18" aria-hidden="true">arrow_drop_down</v-icon>
        </div>
        <div class="couponInfo">
          <div :class="{couponDiscount: true, secondary: couponActive(coupon)}">
            <span v-if="coupon.type === couponTypes.VALUE">-{{ formatPriceShort(coupon.discount) }}</span>
            <span v-if="coupon.type === couponTypes.PERCENTAGE">-{{ coupon.discount }}%</span>
            <v-icon v-if="coupon.type === couponTypes.FREESHIPPING" size="30px">local_shipping</v-icon>
          </div>
          <div class="condition">
            <strong v-if="coupon.type === couponTypes.FREESHIPPING" class="shippingReward">{{ $t('COUPON_REWARD_SHIPPING') }}</strong>
            <span v-html="$t('COUPON_CONDITION').replace('{value}', formatPrice(coupon.minimumValue))"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BasicComponent from '@/global/BasicComponent';
import couponSvg from '@/assets/coupons/coupon.svg?raw';
import {CouponDto, CouponTypeDto} from '@swagger';

@Component
export default class DiscountDetails extends BasicComponent {
  couponSvg = couponSvg;
  couponTypes = CouponTypeDto;
  @Prop({type: Array, required: true}) coupons: CouponDto[];
  @Prop({type: Number, required: true}) subtotal: number;
  @Prop({type: Object, default: null}) nextCoupon: CouponDto | null;
  @Prop({type: String, default: null}) expiryDate: string | null;
  @Prop({type: Boolean, default: false}) modal: boolean;

  couponActive(coupon: CouponDto): boolean {
    return this.subtotal >= coupon.minimumValue;
  }
}
</script>

<style scoped lang="scss">
@use "../stylesheets/Variables.scss" as *;

.discountDetails {
  color: $shop-black;
  background: $shop-white;
  .shippingReward {
    display: block;
  }
  .couponContainer {
    position: relative;

    .coupon {
      display: block;
      width: 100%;

      ::v-deep svg {
        display: block;
        width: 100%;
      }

      ::v-deep .foreground {
        fill: $shop-white;
      }

      ::v-deep .inheritFill {
        fill: currentColor;
      }

    }

    p {
      text-align: left;
      position: absolute;
      left: 45%;

      &.validUntil {
        font-size: 110%;
        top: 20%;
        font-weight: 500;
      }

      &.validUntilDate {
        font-size: clamp(1.25rem, 8.5vw, 2rem);
        white-space: nowrap;
        top: 40%;
      }
    }
  }

  .steps {

    padding-left: 5px;
    padding-right: 5px;

    .discountTitle {
      font-weight: 700;
      font-size: 30px;
      text-align: left;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-left: 5px;
    }

    .v-divider {
      border-top-width: 1px;
    }

    .coupon {
      .missingNext {

        p {
          text-align: center;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .rewardPointer {
          display: block;
          width: 18px;
          margin: 5px auto 0;
        }
      }

      .couponInfo {
        display: flex;
        padding-top: 10px;
        padding-bottom: 10px;
        align-items: center;

        .couponDiscount {
          $size: 30px;
          height: $size;
          width: $size;
          border: $size solid $shop-coupon-inactive;
          border-radius: $size;
          background-color: transparent !important;
          position: relative;

          * {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          span {
            font-size: 16px;
            font-weight: 500;
          }

          .v-icon {
            color: $shop-white;
            transform: translate(calc(-50% + 2px), -50%);
          }
        }

        .condition {
          margin: 0;
          margin-left: 15px;
          font-size: 16px;
        }
      }
    }
  }
}
.discountDetails.modal {
  position: relative;
  padding: 5px;
  border: 3px solid var(--v-secondary-base);
  border-radius: 6px;
  .closeDetails {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
  }
}
</style>
